import { useMemo } from "react";
import { Route, RouteProps } from "react-router-dom";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Loading from "../../Loading/Loading";
import { Box } from "@mui/material";

export default function PrivateRoute({ component, ...rest }: RouteProps) {
  // Wrap once per `component`. Calling withAuthenticationRequired inline would
  // produce a new component identity on every render, so React Router would
  // unmount/remount the page (losing its state) whenever navigation — e.g. a
  // tab or query change within the same route — re-renders the Switch.
  const Protected = useMemo(
    () =>
      withAuthenticationRequired(component as any, {
        onRedirecting: () => (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
          >
            <Loading />
          </Box>
        )
      }),
    [component]
  );

  return <Route component={Protected} {...rest} />;
}
